import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@deliveryhero/armor-icons';
import { useComponentTheme } from '../../utils/hooks';
import { usePageNavigationClassNames } from './utils/usePageNavigationClassNames';
import { usePageNavigation } from './utils/usePageNavigation';
import { PageNavigationRoot, PageNavigationButtons, PageNavigationPageButton, PageNavigationPageSize, PageNavigationPageSizeSelector } from './style';
import { pageNavigationDefaultTheme } from './theme';
import { pageNavigationRootTestId, PAGE_NAVIGATION_CLASS_PREFIX, pageNavigationPageButtonTestId } from './constants';
export var PageNavigation = forwardRef(function PageNavigation(_ref, ref) {
  var className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(PAGE_NAVIGATION_CLASS_PREFIX, pageNavigationDefaultTheme);
  var classNameComponents = usePageNavigationClassNames(PAGE_NAVIGATION_CLASS_PREFIX, className);

  var _usePageNavigation = usePageNavigation(restProps),
      pageSizeSelectorProps = _usePageNavigation.pageSizeSelectorProps,
      _usePageNavigation$st = _usePageNavigation.structure,
      displayedRange = _usePageNavigation$st.displayedRange,
      nextPageNumber = _usePageNavigation$st.nextPageNumber,
      previousPageNumber = _usePageNavigation$st.previousPageNumber,
      currentPageNumber = _usePageNavigation$st.currentPageNumber,
      nextPageArrowEnabled = _usePageNavigation$st.nextPageArrowEnabled,
      previousPageArrowEnabled = _usePageNavigation$st.previousPageArrowEnabled,
      onPageButtonClick = _usePageNavigation.onPageButtonClick,
      enablePageSizeSelector = _usePageNavigation.enablePageSizeSelector;

  return React.createElement(PageNavigationRoot, Object.assign({
    "data-testid": pageNavigationRootTestId
  }, restProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: ref
  }), enablePageSizeSelector && React.createElement(PageNavigationPageSize, {
    theme: theme,
    className: classNameComponents.PageSize
  }, "Rows per page:", ' ', React.createElement(PageNavigationPageSizeSelector, Object.assign({
    theme: theme,
    className: classNameComponents.PageSizeSelector
  }, pageSizeSelectorProps))), React.createElement(PageNavigationButtons, {
    theme: theme,
    className: classNameComponents.Buttons
  }, React.createElement(PageNavigationPageButton, {
    theme: theme,
    className: classNameComponents.ArrowButton,
    arrow: true,
    disabled: !previousPageArrowEnabled,
    "data-testid": pageNavigationPageButtonTestId,
    "data-disabled": previousPageArrowEnabled ? '' : '1',
    "data-pagenumber": previousPageNumber,
    onClick: onPageButtonClick
  }, React.createElement(ArrowLeftIcon, null)), displayedRange.map(function (pageNumber) {
    return React.createElement(PageNavigationPageButton, {
      key: pageNumber,
      theme: theme,
      className: classNameComponents.PageButton,
      selected: pageNumber === currentPageNumber,
      "data-testid": pageNavigationPageButtonTestId,
      "data-disabled": "",
      "data-pagenumber": pageNumber,
      onClick: onPageButtonClick
    }, pageNumber);
  }), React.createElement(PageNavigationPageButton, {
    theme: theme,
    className: classNameComponents.ArrowButton,
    arrow: true,
    disabled: !nextPageArrowEnabled,
    "data-testid": pageNavigationPageButtonTestId,
    "data-disabled": nextPageArrowEnabled ? '' : '1',
    "data-pagenumber": nextPageNumber,
    onClick: onPageButtonClick
  }, React.createElement(ArrowRightIcon, null))));
});
PageNavigation.defaultProps = {
  pageNumber: 1,
  itemCount: 0,
  pageSize: 25,
  displayRange: 2,
  pageSizeList: [{
    label: '25',
    value: 25
  }, {
    label: '100',
    value: 100
  }, {
    label: '500',
    value: 500
  }]
};